module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-01 7.dd0e0947.png";